import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface PhotoEntryValueProps
	extends Omit<BaseEntryValueProps, "value"> {
	value: string | null;
}

export function PhotoEntryValue({
	value,
	inputLabel,
	size,
	...props
}: PhotoEntryValueProps) {
	return (
		<BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
			<img
				src={value || ""}
				alt={inputLabel || "Uploaded Image"}
				className={cn(
					"max-w-full h-auto",
					size === "sm" && "max-h-24",
					size === "md" && "max-h-32",
					size === "lg" && "max-h-48",
				)}
			/>
		</BaseEntryValue>
	);
}
